const IconMap = new Map([
    ['IconSprite360ThickShape', '360--thick-shape'],
    ['IconSprite360Thick', '360--thick'],
    ['IconSprite360Shape', '360-shape'],
    ['IconSprite360', '360'],
    ['IconSpriteAppleFilledShape', 'apple--filled-shape'],
    ['IconSpriteAppleFilled', 'apple--filled'],
    ['IconSpriteArchiveFilledShape', 'archive--filled-shape'],
    ['IconSpriteArchiveFilled', 'archive--filled'],
    ['IconSpriteAreaChartThickShape', 'area-chart--thick-shape'],
    ['IconSpriteAreaChartShape', 'area-chart-shape'],
    ['IconSpriteAreaSizeThickShape', 'area-size--thick-shape'],
    ['IconSpriteAreaSizeShape', 'area-size-shape'],
    ['IconSpriteAreaChartThick', 'area_chart--thick'],
    ['IconSpriteAreaChart', 'area_chart'],
    ['IconSpriteAreaSizeThick', 'area_size--thick'],
    ['IconSpriteAreaSize', 'area_size'],
    ['IconSpriteArrowCircleClockwiseShape', 'arrow-circle-clockwise-shape'],
    ['IconSpriteArrowCircleCounterclockwiseShape', 'arrow-circle-counterclockwise-shape'],
    ['IconSpriteArrowDownThickShape', 'arrow-down--thick-shape'],
    ['IconSpriteArrowDownShape', 'arrow-down-shape'],
    ['IconSpriteArrowLeftThickShape', 'arrow-left--thick-shape'],
    ['IconSpriteArrowLeftShape', 'arrow-left-shape'],
    ['IconSpriteArrowNarrowDownThickShape', 'arrow-narrow-down--thick-shape'],
    ['IconSpriteArrowNarrowUpThickShape', 'arrow-narrow-up--thick-shape'],
    ['IconSpriteArrowRightThickShape', 'arrow-right--thick-shape'],
    ['IconSpriteArrowRightShape', 'arrow-right-shape'],
    ['IconSpriteArrowUpThickShape', 'arrow-up--thick-shape'],
    ['IconSpriteArrowUpShape', 'arrow-up-shape'],
    ['IconSpriteArrowZigzagDownThickShape', 'arrow-zigzag-down--thick-shape'],
    ['IconSpriteArrowZigzagDownShape', 'arrow-zigzag-down-shape'],
    ['IconSpriteArrowZigzagUpThickShape', 'arrow-zigzag-up--thick-shape'],
    ['IconSpriteArrowZigzagUpShape', 'arrow-zigzag-up-shape'],
    ['IconSpriteArrowCircleClockwise', 'arrow_circle_clockwise'],
    ['IconSpriteArrowCircleCounterclockwise', 'arrow_circle_counterclockwise'],
    ['IconSpriteArrowDownThick', 'arrow_down--thick'],
    ['IconSpriteArrowDown', 'arrow_down'],
    ['IconSpriteArrowLeftThick', 'arrow_left--thick'],
    ['IconSpriteArrowLeft', 'arrow_left'],
    ['IconSpriteArrowNarrowDownThick', 'arrow_narrow_down--thick'],
    ['IconSpriteArrowNarrowUpThick', 'arrow_narrow_up--thick'],
    ['IconSpriteArrowRightThick', 'arrow_right--thick'],
    ['IconSpriteArrowRight', 'arrow_right'],
    ['IconSpriteArrowUpThick', 'arrow_up--thick'],
    ['IconSpriteArrowUp', 'arrow_up'],
    ['IconSpriteArrowZigzagDownThick', 'arrow_zigzag_down--thick'],
    ['IconSpriteArrowZigzagDown', 'arrow_zigzag_down'],
    ['IconSpriteArrowZigzagUpThick', 'arrow_zigzag_up--thick'],
    ['IconSpriteArrowZigzagUp', 'arrow_zigzag_up'],
    ['IconSpriteArrowsCircleThickShape', 'arrows-circle--thick-shape'],
    ['IconSpriteArrowsExpandThickShape', 'arrows-expand--thick-shape'],
    ['IconSpriteArrowsExpandShape', 'arrows-expand-shape'],
    ['IconSpriteArrowsUpDownThickShape', 'arrows-up-down--thick-shape'],
    ['IconSpriteArrowsUpDownShape', 'arrows-up-down-shape'],
    ['IconSpriteArrowsCircleThick', 'arrows_circle--thick'],
    ['IconSpriteArrowsExpandThick', 'arrows_expand--thick'],
    ['IconSpriteArrowsExpand', 'arrows_expand'],
    ['IconSpriteArrowsUpDownThick', 'arrows_up_down--thick'],
    ['IconSpriteArrowsUpDown', 'arrows_up_down'],
    ['IconSpriteBadgeFilledShape', 'badge--filled-shape'],
    ['IconSpriteBadgeFilled', 'badge--filled'],
    ['IconSpriteBalconyShape', 'balcony-shape'],
    ['IconSpriteBalcony', 'balcony'],
    ['IconSpriteBarbecueShape', 'barbecue-shape'],
    ['IconSpriteBarbecue', 'barbecue'],
    ['IconSpriteBathtubThickShape', 'bathtub--thick-shape'],
    ['IconSpriteBathtubThick', 'bathtub--thick'],
    ['IconSpriteBathtubShape', 'bathtub-shape'],
    ['IconSpriteBathtub', 'bathtub'],
    ['IconSpriteBeachBallShape', 'beach-ball-shape'],
    ['IconSpriteBeachBall', 'beach_ball'],
    ['IconSpriteBedThickShape', 'bed--thick-shape'],
    ['IconSpriteBedThick', 'bed--thick'],
    ['IconSpriteBedShape', 'bed-shape'],
    ['IconSpriteBed', 'bed'],
    ['IconSpriteBellFilledShape', 'bell-filled-shape'],
    ['IconSpriteBellFilled', 'bell-filled'],
    ['IconSpriteBellShape', 'bell-shape'],
    ['IconSpriteBellThickShape', 'bell-thick-shape'],
    ['IconSpriteBellThick', 'bell-thick'],
    ['IconSpriteBell', 'bell'],
    ['IconSpriteBinFilledShape', 'bin--filled-shape'],
    ['IconSpriteBinFilled', 'bin--filled'],
    ['IconSpriteBinThickShape', 'bin--thick-shape'],
    ['IconSpriteBinThick', 'bin--thick'],
    ['IconSpriteBinShape', 'bin-shape'],
    ['IconSpriteBin', 'bin'],
    ['IconSpriteBinocularFilledShape', 'binocular--filled-shape'],
    ['IconSpriteBinocularFilled', 'binocular--filled'],
    ['IconSpriteBinocularShape', 'binocular-shape'],
    ['IconSpriteBinocular', 'binocular'],
    ['IconSpriteBookOpenThickShape', 'book-open--thick-shape'],
    ['IconSpriteBookOpenShape', 'book-open-shape'],
    ['IconSpriteBookOpenThick', 'book_open--thick'],
    ['IconSpriteBookOpen', 'book_open'],
    ['IconSpriteBricksThickShape', 'bricks--thick-shape'],
    ['IconSpriteBricksThick', 'bricks--thick'],
    ['IconSpriteBricksShape', 'bricks-shape'],
    ['IconSpriteBricks', 'bricks'],
    ['IconSpriteBriefcaseFilledShape', 'briefcase--filled-shape'],
    ['IconSpriteBriefcaseFilled', 'briefcase--filled'],
    ['IconSpriteBriefcaseThickShape', 'briefcase--thick-shape'],
    ['IconSpriteBriefcaseThick', 'briefcase--thick'],
    ['IconSpriteBroomShape', 'broom-shape'],
    ['IconSpriteBroom', 'broom'],
    ['IconSpriteBubblesShape', 'bubbles-shape'],
    ['IconSpriteBubbles', 'bubbles'],
    ['IconSpriteBuilding2FilledShape', 'building-2--filled-shape'],
    ['IconSpriteBuilding2ThickShape', 'building-2--thick-shape'],
    ['IconSpriteBuilding2Shape', 'building-2-shape'],
    ['IconSpriteBuilding2Filled', 'building_2--filled'],
    ['IconSpriteBuilding2Thick', 'building_2--thick'],
    ['IconSpriteBuilding2', 'building_2'],
    ['IconSpriteBuildingsAltThickShape', 'buildings-alt--thick-shape'],
    ['IconSpriteBuildingsAltShape', 'buildings-alt-shape'],
    ['IconSpriteBuildingsShape', 'buildings-shape'],
    ['IconSpriteBuildingsStarThickShape', 'buildings-star--thick-shape'],
    ['IconSpriteBuildingsStarShape', 'buildings-star-shape'],
    ['IconSpriteBuildings', 'buildings'],
    ['IconSpriteBuildingsAltThick', 'buildings_alt--thick'],
    ['IconSpriteBuildingsAlt', 'buildings_alt'],
    ['IconSpriteBuildingsStarThick', 'buildings_star--thick'],
    ['IconSpriteBuildingsStar', 'buildings_star'],
    ['IconSpriteBurjKhalifaShape', 'burj-khalifa-shape'],
    ['IconSpriteBurjKhalifa', 'burj_khalifa'],
    ['IconSpriteCalendarThickShape', 'calendar--thick-shape'],
    ['IconSpriteCalendarThick', 'calendar--thick'],
    ['IconSpriteCalendarShape', 'calendar-shape'],
    ['IconSpriteCalendar', 'calendar'],
    ['IconSpriteCarCircleFilledShape', 'car-circle--filled-shape'],
    ['IconSpriteCarCircleThickShape', 'car-circle--thick-shape'],
    ['IconSpriteCarCircleShape', 'car-circle-shape'],
    ['IconSpriteCarClockThickShape', 'car-clock--thick-shape'],
    ['IconSpriteCarClockShape', 'car-clock-shape'],
    ['IconSpriteCarCircleFilled', 'car_circle--filled'],
    ['IconSpriteCarCircleThick', 'car_circle--thick'],
    ['IconSpriteCarCircle', 'car_circle'],
    ['IconSpriteCarClockThick', 'car_clock--thick'],
    ['IconSpriteCarClock', 'car_clock'],
    ['IconSpriteCheckmarkThickShape', 'checkmark--thick-shape'],
    ['IconSpriteCheckmarkThick', 'checkmark--thick'],
    ['IconSpriteCheckmarkCircleFilledShape', 'checkmark-circle--filled-shape'],
    ['IconSpriteCheckmarkCircleThickShape', 'checkmark-circle--thick-shape'],
    ['IconSpriteCheckmarkCircleShape', 'checkmark-circle-shape'],
    ['IconSpriteCheckmarkShape', 'checkmark-shape'],
    ['IconSpriteCheckmark', 'checkmark'],
    ['IconSpriteCheckmarkCircleFilled', 'checkmark_circle--filled'],
    ['IconSpriteCheckmarkCircleThick', 'checkmark_circle--thick'],
    ['IconSpriteCheckmarkCircle', 'checkmark_circle'],
    ['IconSpriteChevronDownThickShape', 'chevron-down--thick-shape'],
    ['IconSpriteChevronDownShape', 'chevron-down-shape'],
    ['IconSpriteChevronDownSmallFilledShape', 'chevron-down-small--filled-shape'],
    ['IconSpriteChevronDownSmallThickShape', 'chevron-down-small--thick-shape'],
    ['IconSpriteChevronDownSmallShape', 'chevron-down-small-shape'],
    ['IconSpriteChevronLeftThickShape', 'chevron-left--thick-shape'],
    ['IconSpriteChevronLeftShape', 'chevron-left-shape'],
    ['IconSpriteChevronLeftSmallFilledShape', 'chevron-left-small--filled-shape'],
    ['IconSpriteChevronLeftSmallThickShape', 'chevron-left-small--thick-shape'],
    ['IconSpriteChevronLeftSmallShape', 'chevron-left-small-shape'],
    ['IconSpriteChevronRightThickShape', 'chevron-right--thick-shape'],
    ['IconSpriteChevronRightShape', 'chevron-right-shape'],
    ['IconSpriteChevronRightSmallFilledShape', 'chevron-right-small--filled-shape'],
    ['IconSpriteChevronRightSmallThickShape', 'chevron-right-small--thick-shape'],
    ['IconSpriteChevronRightSmallShape', 'chevron-right-small-shape'],
    ['IconSpriteChevronUpThickShape', 'chevron-up--thick-shape'],
    ['IconSpriteChevronUpShape', 'chevron-up-shape'],
    ['IconSpriteChevronUpSmallFilledShape', 'chevron-up-small--filled-shape'],
    ['IconSpriteChevronUpSmallThickShape', 'chevron-up-small--thick-shape'],
    ['IconSpriteChevronUpSmallShape', 'chevron-up-small-shape'],
    ['IconSpriteChevronDownThick', 'chevron_down--thick'],
    ['IconSpriteChevronDown', 'chevron_down'],
    ['IconSpriteChevronDownSmallFilled', 'chevron_down_small--filled'],
    ['IconSpriteChevronDownSmallThick', 'chevron_down_small--thick'],
    ['IconSpriteChevronDownSmall', 'chevron_down_small'],
    ['IconSpriteChevronLeftThick', 'chevron_left--thick'],
    ['IconSpriteChevronLeft', 'chevron_left'],
    ['IconSpriteChevronLeftSmallFilled', 'chevron_left_small--filled'],
    ['IconSpriteChevronLeftSmallThick', 'chevron_left_small--thick'],
    ['IconSpriteChevronLeftSmall', 'chevron_left_small'],
    ['IconSpriteChevronRightThick', 'chevron_right--thick'],
    ['IconSpriteChevronRight', 'chevron_right'],
    ['IconSpriteChevronRightSmallFilled', 'chevron_right_small--filled'],
    ['IconSpriteChevronRightSmallThick', 'chevron_right_small--thick'],
    ['IconSpriteChevronRightSmall', 'chevron_right_small'],
    ['IconSpriteChevronUpThick', 'chevron_up--thick'],
    ['IconSpriteChevronUp', 'chevron_up'],
    ['IconSpriteChevronUpSmallFilled', 'chevron_up_small--filled'],
    ['IconSpriteChevronUpSmallThick', 'chevron_up_small--thick'],
    ['IconSpriteChevronUpSmall', 'chevron_up_small'],
    ['IconSpriteCircleShape', 'circle-shape'],
    ['IconSpriteCircle', 'circle'],
    ['IconSpriteClockFilledShape', 'clock--filled-shape'],
    ['IconSpriteClockFilled', 'clock--filled'],
    ['IconSpriteClockHistoryThickShape', 'clock-history--thick-shape'],
    ['IconSpriteClockHistoryShape', 'clock-history-shape'],
    ['IconSpriteClockShape', 'clock-shape'],
    ['IconSpriteClock', 'clock'],
    ['IconSpriteClockHistoryThick', 'clock_history--thick'],
    ['IconSpriteClockHistory', 'clock_history'],
    ['IconSpriteClosetShape', 'closet-shape'],
    ['IconSpriteCloset', 'closet'],
    ['IconSpriteCogFilledShape', 'cog--filled-shape'],
    ['IconSpriteCogFilled', 'cog--filled'],
    ['IconSpriteCogShape', 'cog-shape'],
    ['IconSpriteCog', 'cog'],
    ['IconSpriteCoinsStackAverageShape', 'coins-stack-average-shape'],
    ['IconSpriteCoinsStackMinShape', 'coins-stack-min-shape'],
    ['IconSpriteCoinsStackShape', 'coins-stack-shape'],
    ['IconSpriteCoinsStack', 'coins_stack'],
    ['IconSpriteCoinsStackAverage', 'coins_stack_average'],
    ['IconSpriteCoinsStackMin', 'coins_stack_min'],
    ['IconSpriteCompassThickShape', 'compass--thick-shape'],
    ['IconSpriteCompassThick', 'compass--thick'],
    ['IconSpriteCompassShape', 'compass-shape'],
    ['IconSpriteCompass', 'compass'],
    ['IconSpriteConciergeShape', 'concierge-shape'],
    ['IconSpriteConcierge', 'concierge'],
    ['IconSpriteCraneShape', 'crane-shape'],
    ['IconSpriteCrane', 'crane'],
    ['IconSpriteCrownFilledShape', 'crown--filled-shape'],
    ['IconSpriteCrownFilled', 'crown--filled'],
    ['IconSpriteCrownShape', 'crown-shape'],
    ['IconSpriteCrown', 'crown'],
    ['IconSpriteCutleryAndDishShape', 'cutlery-and-dish-shape'],
    ['IconSpriteCutleryShape', 'cutlery-shape'],
    ['IconSpriteCutlery', 'cutlery'],
    ['IconSpriteCutleryAndDish', 'cutlery_and_dish'],
    ['IconSpriteDataguruShape', 'dataguru-shape'],
    ['IconSpriteDataguru', 'dataguru'],
    ['IconSpriteDiamondThickShape', 'diamond--thick-shape'],
    ['IconSpriteDiamondThick', 'diamond--thick'],
    ['IconSpriteDocumentThickShape', 'document--thick-shape'],
    ['IconSpriteDocumentThick', 'document--thick'],
    ['IconSpriteDocumentShape', 'document-shape'],
    ['IconSpriteDocument', 'document'],
    ['IconSpriteDogFootprintShape', 'dog-footprint-shape'],
    ['IconSpriteDogFootprint', 'dog_footprint'],
    ['IconSpriteDollarArrowsShape', 'dollar-arrows-shape'],
    ['IconSpriteDollarArrows', 'dollar_arrows'],
    ['IconSpriteDoorThick', 'door--thick'],
    ['IconSpriteDoorShape', 'door-shape'],
    ['IconSpriteDoor', 'door'],
    ['IconSpriteDownloadThickShape', 'download--thick-shape'],
    ['IconSpriteDownloadThick', 'download--thick'],
    ['IconSpriteDownloadShape', 'download-shape'],
    ['IconSpriteDownload', 'download'],
    ['IconSpriteDumbbellShape', 'dumbbell-shape'],
    ['IconSpriteDumbbell', 'dumbbell'],
    ['IconSpriteEditSquareThickShape', 'edit-square--thick-shape'],
    ['IconSpriteEditSquareShape', 'edit-square-shape'],
    ['IconSpriteEditSquareThick', 'edit_square--thick'],
    ['IconSpriteEditSquare', 'edit_square'],
    ['IconSpriteElectricPlugThickShape', 'electric-plug--thick-shape'],
    ['IconSpriteElectricPlugDisabledThickShape', 'electric-plug-disabled--thick-shape'],
    ['IconSpriteElectricPlugThick', 'electric_plug--thick'],
    ['IconSpriteElectricPlugDisabledThick', 'electric_plug_disabled--thick'],
    ['IconSpriteEnvelopeFilledShape', 'envelope--filled-shape'],
    ['IconSpriteEnvelopeFilled', 'envelope--filled'],
    ['IconSpriteEnvelopeShape', 'envelope-shape'],
    ['IconSpriteEnvelope', 'envelope'],
    ['IconSpriteExternalLinkThickShape', 'external-link--thick-shape'],
    ['IconSpriteExternalLinkShape', 'external-link-shape'],
    ['IconSpriteExternalLinkThick', 'external_link--thick'],
    ['IconSpriteExternalLink', 'external_link'],
    ['IconSpriteEyeThickShape', 'eye--thick-shape'],
    ['IconSpriteEyeThick', 'eye--thick'],
    ['IconSpriteEyeClosedThickShape', 'eye-closed--thick-shape'],
    ['IconSpriteEyeClosedShape', 'eye-closed-shape'],
    ['IconSpriteEyeShape', 'eye-shape'],
    ['IconSpriteEye', 'eye'],
    ['IconSpriteEyeClosedThick', 'eye_closed--thick'],
    ['IconSpriteEyeClosed', 'eye_closed'],
    ['IconSpriteFacebookFilledShape', 'facebook--filled-shape'],
    ['IconSpriteFacebookFilled', 'facebook--filled'],
    ['IconSpriteFalLicenseShape', 'fal-license-shape'],
    ['IconSpriteFalLicense', 'fal_license'],
    ['IconSpriteFilterThickShape', 'filter--thick-shape'],
    ['IconSpriteFilterThick', 'filter--thick'],
    ['IconSpriteFilterClearThickShape', 'filter-clear--thick-shape'],
    ['IconSpriteFilterShape', 'filter-shape'],
    ['IconSpriteFilter', 'filter'],
    ['IconSpriteFilterClearThick', 'filter_clear--thick'],
    ['IconSpriteFireplaceFilledShape', 'fireplace--filled-shape'],
    ['IconSpriteFireplaceFilled', 'fireplace--filled'],
    ['IconSpriteFireplaceThickShape', 'fireplace--thick-shape'],
    ['IconSpriteFireplaceThick', 'fireplace--thick'],
    ['IconSpriteFireplaceShape', 'fireplace-shape'],
    ['IconSpriteFireplace', 'fireplace'],
    ['IconSpriteFlagFilledShape', 'flag--filled-shape'],
    ['IconSpriteFlagFilled', 'flag--filled'],
    ['IconSpriteFlagThickShape', 'flag--thick-shape'],
    ['IconSpriteFlagThick', 'flag--thick'],
    ['IconSpriteFlagShape', 'flag-shape'],
    ['IconSpriteFlag', 'flag'],
    ['IconSpriteFloorplanThickShape', 'floorplan--thick-shape'],
    ['IconSpriteFloorplanThick', 'floorplan--thick'],
    ['IconSpriteFloorplanShape', 'floorplan-shape'],
    ['IconSpriteFloorplan', 'floorplan'],
    ['IconSpriteFullscreenThickShape', 'fullscreen--thick-shape'],
    ['IconSpriteFullscreenThick', 'fullscreen--thick'],
    ['IconSpriteFullscreenShape', 'fullscreen-shape'],
    ['IconSpriteFullscreen', 'fullscreen'],
    ['IconSpriteFurnitureThickShape', 'furniture--thick-shape'],
    ['IconSpriteFurnitureThick', 'furniture--thick'],
    ['IconSpriteFurnitureShape', 'furniture-shape'],
    ['IconSpriteFurniture', 'furniture'],
    ['IconSpriteGLetterThickShape', 'g-letter--thick-shape'],
    ['IconSpriteGLetterThick', 'g_letter--thick'],
    ['IconSpriteGoogleFilledShape', 'google--filled-shape'],
    ['IconSpriteGoogleFilled', 'google--filled'],
    ['IconSpriteGridLayoutFilledShape', 'grid-layout--filled-shape'],
    ['IconSpriteGridLayoutShape', 'grid-layout-shape'],
    ['IconSpriteGridLayoutFilled', 'grid_layout--filled'],
    ['IconSpriteGridLayout', 'grid_layout'],
    ['IconSpriteGroceriesFilledShape', 'groceries--filled-shape'],
    ['IconSpriteGroceriesFilled', 'groceries--filled'],
    ['IconSpriteGroupPeopleShape', 'group-people-shape'],
    ['IconSpriteGroupPeople', 'group_people'],
    ['IconSpriteHangerShape', 'hanger-shape'],
    ['IconSpriteHanger', 'hanger'],
    ['IconSpriteHeadHeartFilledShape', 'head-heart--filled-shape'],
    ['IconSpriteHeadHeartFilled', 'head_heart--filled'],
    ['IconSpriteHeartFilledShape', 'heart--filled-shape'],
    ['IconSpriteHeartFilled', 'heart--filled'],
    ['IconSpriteHeartThickShape', 'heart--thick-shape'],
    ['IconSpriteHeartThick', 'heart--thick'],
    ['IconSpriteHeartShape', 'heart-shape'],
    ['IconSpriteHeart', 'heart'],
    ['IconSpriteHistoricPillarShape', 'historic-pillar-shape'],
    ['IconSpriteHistoricPillar', 'historic_pillar'],
    ['IconSpriteHolidayFilledShape', 'holiday--filled-shape'],
    ['IconSpriteHolidayFilled', 'holiday--filled'],
    ['IconSpriteHospitalsFilledShape', 'hospitals--filled-shape'],
    ['IconSpriteHospitalsFilled', 'hospitals--filled'],
    ['IconSpriteHourglassFilledShape', 'hourglass--filled-shape'],
    ['IconSpriteHourglassFilled', 'hourglass--filled'],
    ['IconSpriteHouseFilledShape', 'house--filled-shape'],
    ['IconSpriteHouseFilled', 'house--filled'],
    ['IconSpriteHouseThickShape', 'house--thick-shape'],
    ['IconSpriteHouseThick', 'house--thick'],
    ['IconSpriteHouseArrowShape', 'house-arrow-shape'],
    ['IconSpriteHouseListFilledShape', 'house-list--filled-shape'],
    ['IconSpriteHouseListShape', 'house-list-shape'],
    ['IconSpriteHousePercentageShape', 'house-percentage-shape'],
    ['IconSpriteHouseShape', 'house-shape'],
    ['IconSpriteHouse', 'house'],
    ['IconSpriteHouseArrow', 'house_arrow'],
    ['IconSpriteHouseListFilled', 'house_list--filled'],
    ['IconSpriteHouseList', 'house_list'],
    ['IconSpriteHousePercentage', 'house_percentage'],
    ['IconSpriteInfoCircleFilledShape', 'info-circle--filled-shape'],
    ['IconSpriteInfoCircleShape', 'info-circle-shape'],
    ['IconSpriteInfoCircleFilled', 'info_circle--filled'],
    ['IconSpriteInfoCircle', 'info_circle'],
    ['IconSpriteInternetSocketShape', 'internet-socket-shape'],
    ['IconSpriteInternetSocket', 'internet_socket'],
    ['IconSpriteLayersShape', 'layers-shape'],
    ['IconSpriteLayers', 'layers'],
    ['IconSpriteLightningFilledShape', 'lightning--filled-shape'],
    ['IconSpriteLightningFilled', 'lightning--filled'],
    ['IconSpriteLightningThickShape', 'lightning--thick-shape'],
    ['IconSpriteLightningThick', 'lightning--thick'],
    ['IconSpriteLightningShape', 'lightning-shape'],
    ['IconSpriteLightning', 'lightning'],
    ['IconSpriteListFilledShape', 'list--filled-shape'],
    ['IconSpriteListFilled', 'list--filled'],
    ['IconSpriteListThickShape', 'list--thick-shape'],
    ['IconSpriteListThick', 'list--thick'],
    ['IconSpriteListShape', 'list-shape'],
    ['IconSpriteListViewFilledShape', 'list-view--filled-shape'],
    ['IconSpriteListViewThickShape', 'list-view--thick-shape'],
    ['IconSpriteListViewShape', 'list-view-shape'],
    ['IconSpriteList', 'list'],
    ['IconSpriteListViewFilled', 'list_view--filled'],
    ['IconSpriteListViewThick', 'list_view--thick'],
    ['IconSpriteListView', 'list_view'],
    ['IconSpriteLiveThickShape', 'live--thick-shape'],
    ['IconSpriteLiveThick', 'live--thick'],
    ['IconSpriteLoaderShape', 'loader-shape'],
    ['IconSpriteLoader', 'loader'],
    ['IconSpriteLocationArrowFilledShape', 'location-arrow--filled-shape'],
    ['IconSpriteLocationArrowThickShape', 'location-arrow--thick-shape'],
    ['IconSpriteLocationArrowShape', 'location-arrow-shape'],
    ['IconSpriteLocationGpsThickShape', 'location-gps--thick-shape'],
    ['IconSpriteLocationArrowFilled', 'location_arrow--filled'],
    ['IconSpriteLocationArrowThick', 'location_arrow--thick'],
    ['IconSpriteLocationArrow', 'location_arrow'],
    ['IconSpriteLocationGpsThick', 'location_gps--thick'],
    ['IconSpriteLockFilledShape', 'lock--filled-shape'],
    ['IconSpriteLockFilled', 'lock--filled'],
    ['IconSpriteLockThickShape', 'lock--thick-shape'],
    ['IconSpriteLockThick', 'lock--thick'],
    ['IconSpriteLockShape', 'lock-shape'],
    ['IconSpriteLock', 'lock'],
    ['IconSpriteLotusPlantShape', 'lotus-plant-shape'],
    ['IconSpriteLotusPlant', 'lotus_plant'],
    ['IconSpriteMagnifierFilledShape', 'magnifier--filled-shape'],
    ['IconSpriteMagnifierFilled', 'magnifier--filled'],
    ['IconSpriteMagnifierThickShape', 'magnifier--thick-shape'],
    ['IconSpriteMagnifierThick', 'magnifier--thick'],
    ['IconSpriteMagnifierMinusShape', 'magnifier-minus-shape'],
    ['IconSpriteMagnifierPlusShape', 'magnifier-plus-shape'],
    ['IconSpriteMagnifierShape', 'magnifier-shape'],
    ['IconSpriteMagnifier', 'magnifier'],
    ['IconSpriteMagnifierMinus', 'magnifier_minus'],
    ['IconSpriteMagnifierPlus', 'magnifier_plus'],
    ['IconSpriteMapPinFilledShape', 'map-pin--filled-shape'],
    ['IconSpriteMapPinThickShape', 'map-pin--thick-shape'],
    ['IconSpriteMapPinPlusThickShape', 'map-pin-plus--thick-shape'],
    ['IconSpriteMapPinShape', 'map-pin-shape'],
    ['IconSpriteMapPinFilled', 'map_pin--filled'],
    ['IconSpriteMapPinThick', 'map_pin--thick'],
    ['IconSpriteMapPin', 'map_pin'],
    ['IconSpriteMapPinPlusThick', 'map_pin_plus--thick'],
    ['IconSpriteMegaphoneFilledShape', 'megaphone--filled-shape'],
    ['IconSpriteMegaphoneFilled', 'megaphone--filled'],
    ['IconSpriteMegaphoneThickShape', 'megaphone--thick-shape'],
    ['IconSpriteMegaphoneThick', 'megaphone--thick'],
    ['IconSpriteMegaphoneShape', 'megaphone-shape'],
    ['IconSpriteMegaphone', 'megaphone'],
    ['IconSpriteMenuThickShape', 'menu--thick-shape'],
    ['IconSpriteMenuThick', 'menu--thick'],
    ['IconSpriteMenuShape', 'menu-shape'],
    ['IconSpriteMenu', 'menu'],
    ['IconSpriteMetroShape', 'metro-shape'],
    ['IconSpriteMetro', 'metro'],
    ['IconSpriteMezzanineShape', 'mezzanine-shape'],
    ['IconSpriteMezzanine', 'mezzanine'],
    ['IconSpriteMicrophoneFilledShape', 'microphone--filled-shape'],
    ['IconSpriteMicrophoneFilled', 'microphone--filled'],
    ['IconSpriteMicrophoneShape', 'microphone-shape'],
    ['IconSpriteMicrophone', 'microphone'],
    ['IconSpriteMinusThickShape', 'minus--thick-shape'],
    ['IconSpriteMinusThick', 'minus--thick'],
    ['IconSpriteMinusShape', 'minus-shape'],
    ['IconSpriteMinus', 'minus'],
    ['IconSpriteMoneyFilledShape', 'money--filled-shape'],
    ['IconSpriteMoneyFilled', 'money--filled'],
    ['IconSpriteMoneyBillsThickShape', 'money-bills--thick-shape'],
    ['IconSpriteMoneyBillsShape', 'money-bills-shape'],
    ['IconSpriteMoneyBillsThick', 'money_bills--thick'],
    ['IconSpriteMoneyBills', 'money_bills'],
    ['IconSpriteMopShape', 'mop-shape'],
    ['IconSpriteMop', 'mop'],
    ['IconSpriteMoreHorizontalThickShape', 'more-horizontal--thick-shape'],
    ['IconSpriteMoreVerticalThickShape', 'more-vertical--thick-shape'],
    ['IconSpriteMoreHorizontalThick', 'more_horizontal--thick'],
    ['IconSpriteMoreVerticalThick', 'more_vertical--thick'],
    ['IconSpritePalmTreeShape', 'palm-tree-shape'],
    ['IconSpritePalmTree', 'palm_tree'],
    ['IconSpritePaperAirplaneFilledShape', 'paper-airplane--filled-shape'],
    ['IconSpritePaperAirplaneShape', 'paper-airplane-shape'],
    ['IconSpritePaperAirplaneFilled', 'paper_airplane--filled'],
    ['IconSpritePaperAirplane', 'paper_airplane'],
    ['IconSpritePaperplaneThickShape', 'paperplane--thick-shape'],
    ['IconSpritePaperplaneThick', 'paperplane--thick'],
    ['IconSpriteParkingSignShape', 'parking-sign-shape'],
    ['IconSpriteParkingSign', 'parking_sign'],
    ['IconSpritePencilFilledShape', 'pencil--filled-shape'],
    ['IconSpritePencilFilled', 'pencil--filled'],
    ['IconSpritePersonUpFilledShape', 'person-up--filled-shape'],
    ['IconSpritePersonUpThickShape', 'person-up--thick-shape'],
    ['IconSpritePersonUpShape', 'person-up-shape'],
    ['IconSpritePersonUpFilled', 'person_up--filled'],
    ['IconSpritePersonUpThick', 'person_up--thick'],
    ['IconSpritePersonUp', 'person_up'],
    ['IconSpritePhoneFilledShape', 'phone--filled-shape'],
    ['IconSpritePhoneFilled', 'phone--filled'],
    ['IconSpritePhoneShape', 'phone-shape'],
    ['IconSpritePhone', 'phone'],
    ['IconSpritePhotoCameraFilledShape', 'photo-camera--filled-shape'],
    ['IconSpritePhotoCameraThickShape', 'photo-camera--thick-shape'],
    ['IconSpritePhotoCameraShape', 'photo-camera-shape'],
    ['IconSpritePhotoCameraFilled', 'photo_camera--filled'],
    ['IconSpritePhotoCameraThick', 'photo_camera--thick'],
    ['IconSpritePhotoCamera', 'photo_camera'],
    ['IconSpritePinterestFilledShape', 'pinterest--filled-shape'],
    ['IconSpritePinterestFilled', 'pinterest--filled'],
    ['IconSpritePlayThickShape', 'play--thick-shape'],
    ['IconSpritePlayThick', 'play--thick'],
    ['IconSpritePlayShape', 'play-shape'],
    ['IconSpritePlay', 'play'],
    ['IconSpritePlusThickShape', 'plus--thick-shape'],
    ['IconSpritePlusThick', 'plus--thick'],
    ['IconSpritePlusShape', 'plus-shape'],
    ['IconSpritePlus', 'plus'],
    ['IconSpritePoolLadderShape', 'pool-ladder-shape'],
    ['IconSpritePoolLadder', 'pool_ladder'],
    ['IconSpriteQuestionCircleFilledShape', 'question-circle--filled-shape'],
    ['IconSpriteQuestionCircleThickShape', 'question-circle--thick-shape'],
    ['IconSpriteQuestionCircleShape', 'question-circle-shape'],
    ['IconSpriteQuestionCircleFilled', 'question_circle--filled'],
    ['IconSpriteQuestionCircleThick', 'question_circle--thick'],
    ['IconSpriteQuestionCircle', 'question_circle'],
    ['IconSpriteReceptionistShape', 'receptionist-shape'],
    ['IconSpriteReceptionist', 'receptionist'],
    ['IconSpriteReligiousFilledShape', 'religious--filled-shape'],
    ['IconSpriteReligiousFilled', 'religious--filled'],
    ['IconSpriteRentShape', 'rent-shape'],
    ['IconSpriteRent', 'rent'],
    ['IconSpriteRestaurantsFilledShape', 'restaurants--filled-shape'],
    ['IconSpriteRestaurantsFilled', 'restaurants--filled'],
    ['IconSpriteRoadSizeThickShape', 'road-size--thick-shape'],
    ['IconSpriteRoadSizeShape', 'road-size-shape'],
    ['IconSpriteRoadSizeThick', 'road_size--thick'],
    ['IconSpriteRoadSize', 'road_size'],
    ['IconSpriteRobotFilledShape', 'robot--filled-shape'],
    ['IconSpriteRobotFilled', 'robot--filled'],
    ['IconSpriteRoomShape', 'room-shape'],
    ['IconSpriteRoom', 'room'],
    ['IconSpriteRotateCropImageThickShape', 'rotate-crop-image--thick-shape'],
    ['IconSpriteRotateCropImageThick', 'rotate_crop_image--thick'],
    ['IconSpriteSaleShape', 'sale-shape'],
    ['IconSpriteSale', 'sale'],
    ['IconSpriteSchoolsFilledShape', 'schools--filled-shape'],
    ['IconSpriteSchoolsFilled', 'schools--filled'],
    ['IconSpriteScoreShape', 'score-shape'],
    ['IconSpriteScore', 'score'],
    ['IconSpriteShareThickShape', 'share--thick-shape'],
    ['IconSpriteShareThick', 'share--thick'],
    ['IconSpriteShareAltThickShape', 'share-alt--thick-shape'],
    ['IconSpriteShareAltShape', 'share-alt-shape'],
    ['IconSpriteShareShape', 'share-shape'],
    ['IconSpriteShare', 'share'],
    ['IconSpriteShareAltThick', 'share_alt--thick'],
    ['IconSpriteShareAlt', 'share_alt'],
    ['IconSpriteShieldCheckmarkFilledShape', 'shield-checkmark--filled-shape'],
    ['IconSpriteShieldCheckmarkShape', 'shield-checkmark-shape'],
    ['IconSpriteShieldShape', 'shield-shape'],
    ['IconSpriteShield', 'shield'],
    ['IconSpriteShieldCheckmarkFilled', 'shield_checkmark--filled'],
    ['IconSpriteShieldCheckmark', 'shield_checkmark'],
    ['IconSpriteSnowFlakeShape', 'snow-flake-shape'],
    ['IconSpriteSnowFlake', 'snow_flake'],
    ['IconSpriteSortDownThickShape', 'sort-down--thick-shape'],
    ['IconSpriteSortDownShape', 'sort-down-shape'],
    ['IconSpriteSortUpShape', 'sort-up-shape'],
    ['IconSpriteSortDownThick', 'sort_down--thick'],
    ['IconSpriteSortDown', 'sort_down'],
    ['IconSpriteSortUp', 'sort_up'],
    ['IconSpriteSpiceShakersShape', 'spice-shakers-shape'],
    ['IconSpriteSpiceShakers', 'spice_shakers'],
    ['IconSpriteStairsDownThickShape', 'stairs-down--thick-shape'],
    ['IconSpriteStairsDownShape', 'stairs-down-shape'],
    ['IconSpriteStairsDownThick', 'stairs_down--thick'],
    ['IconSpriteStairsDown', 'stairs_down'],
    ['IconSpriteStarFilledShape', 'star--filled-shape'],
    ['IconSpriteStarFilled', 'star--filled'],
    ['IconSpriteStarThickShape', 'star--thick-shape'],
    ['IconSpriteStarThick', 'star--thick'],
    ['IconSpriteStarShape', 'star-shape'],
    ['IconSpriteStarTrophyFilledShape', 'star-trophy--filled-shape'],
    ['IconSpriteStar', 'star'],
    ['IconSpriteStarTrophyFilled', 'star_trophy--filled'],
    ['IconSpriteSunAndWaterShape', 'sun-and-water-shape'],
    ['IconSpriteSunAndWater', 'sun_and_water'],
    ['IconSpriteSwingShape', 'swing-shape'],
    ['IconSpriteSwing', 'swing'],
    ['IconSpriteSwipeShape', 'swipe-shape'],
    ['IconSpriteSwipe', 'swipe'],
    ['IconSpriteTextBubbleFilledShape', 'text-bubble--filled-shape'],
    ['IconSpriteTextBubbleShape', 'text-bubble-shape'],
    ['IconSpriteTextBubbleStarsFilledShape', 'text-bubble-stars--filled-shape'],
    ['IconSpriteTextBubbleFilled', 'text_bubble--filled'],
    ['IconSpriteTextBubble', 'text_bubble'],
    ['IconSpriteTextBubbleStarsFilled', 'text_bubble_stars--filled'],
    ['IconSpriteThreeDotsHorizontalShape', 'three-dots-horizontal-shape'],
    ['IconSpriteThreeDotsVerticalShape', 'three-dots-vertical-shape'],
    ['IconSpriteThreeDotsHorizontal', 'three_dots_horizontal'],
    ['IconSpriteThreeDotsVertical', 'three_dots_vertical'],
    ['IconSpriteThumbDownFilledShape', 'thumb-down--filled-shape'],
    ['IconSpriteThumbUpFilledShape', 'thumb-up--filled-shape'],
    ['IconSpriteThumbDownFilled', 'thumb_down--filled'],
    ['IconSpriteThumbUpFilled', 'thumb_up--filled'],
    ['IconSpriteThumbsUpShape', 'thumbs-up-shape'],
    ['IconSpriteThumbsUp', 'thumbs_up'],
    ['IconSpriteTimesThickShape', 'times--thick-shape'],
    ['IconSpriteTimesThick', 'times--thick'],
    ['IconSpriteTimesCircleFilledShape', 'times-circle--filled-shape'],
    ['IconSpriteTimesCircleThickShape', 'times-circle--thick-shape'],
    ['IconSpriteTimesCircleShape', 'times-circle-shape'],
    ['IconSpriteTimesShape', 'times-shape'],
    ['IconSpriteTimesSmallThickShape', 'times-small--thick-shape'],
    ['IconSpriteTimesSmallShape', 'times-small-shape'],
    ['IconSpriteTimes', 'times'],
    ['IconSpriteTimesCircleFilled', 'times_circle--filled'],
    ['IconSpriteTimesCircleThick', 'times_circle--thick'],
    ['IconSpriteTimesCircle', 'times_circle'],
    ['IconSpriteTimesSmallThick', 'times_small--thick'],
    ['IconSpriteTimesSmall', 'times_small'],
    ['IconSpriteTwitterFilledShape', 'twitter--filled-shape'],
    ['IconSpriteTwitterFilled', 'twitter--filled'],
    ['IconSpriteUserFilledShape', 'user--filled-shape'],
    ['IconSpriteUserFilled', 'user--filled'],
    ['IconSpriteUserThickShape', 'user--thick-shape'],
    ['IconSpriteUserThick', 'user--thick'],
    ['IconSpriteUserShape', 'user-shape'],
    ['IconSpriteUser', 'user'],
    ['IconSpriteVastuStarShape', 'vastu-star-shape'],
    ['IconSpriteVastuStar', 'vastu_star'],
    ['IconSpriteWarningTriangleFilledShape', 'warning-triangle--filled-shape'],
    ['IconSpriteWarningTriangleFilled', 'warning_triangle--filled'],
    ['IconSpriteWhatsappFilledShape', 'whatsapp--filled-shape'],
    ['IconSpriteWhatsappFilled', 'whatsapp--filled'],
    ['IconSpriteWhatsappShape', 'whatsapp-shape'],
    ['IconSpriteWhatsapp', 'whatsapp'],
    ['IconSpriteWorkerThickShape', 'worker--thick-shape'],
    ['IconSpriteWorkerThick', 'worker--thick'],
]);

export { IconMap as I };
